module.exports = __webpack_public_path__ + "static/media/wood2.912da01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wood2.png
// module id = 656
// module chunks = 0